import { c as _c } from "react/compiler-runtime";
import { type RefObject, useCallback, useMemo } from 'react';
import useMutationObserver from '../useMutationObserver';
function useAttributeObserver(ref, attributeName) {
  const $ = _c(9);
  let t0;
  if ($[0] !== attributeName) {
    t0 = mutation => mutation.type === "attributes" && mutation.attributeName === attributeName;
    $[0] = attributeName;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const filter = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      attributes: true
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const record = useMutationObserver(ref, filter, t1);
  const oldValue = record?.oldValue ?? null;
  let t2;
  if ($[3] !== attributeName || $[4] !== record?.target) {
    t2 = (record?.target as HTMLElement ?? null)?.getAttribute(attributeName);
    $[3] = attributeName;
    $[4] = record?.target;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const newValue = t2;
  let t3;
  if ($[6] !== newValue || $[7] !== oldValue) {
    t3 = {
      oldValue,
      newValue
    };
    $[6] = newValue;
    $[7] = oldValue;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const result = t3;
  return result;
}
export default useAttributeObserver;